import {LuSearch,LuChevronDown} from "@/Components/Icons/Icons"; 

export default {
    row1 : [
    {
        column:"column1",
       
        rows:{
            row1: [
                {
                    name: "Type",
                    label: "Type",
                    component:"dropdown",
                    endIconName: LuChevronDown,
                    iconColor: "gray-400",  

                },
            ],
            row2:[
                {
                    name: "Name",
                    label: "Name",
                    component: "text-field",   

                },
            ],
            row3:[
                {
                    name: "city",
                    label: "City",
                    component: "text-field"   
                   

                },
               
            ],
            row4:[
                {
                    name: "Postal Code",
                    label: "Postal Code",
                    component: "text-field",   
                   

                },
            ],
            row5:[
                {
                    name: "address",
                    actionText: "Address",
                    component: "textarea", 
                    height:"100px",
                    sx: {
                        borderRadius: 10,
                    }
                },
            ],
           
        }
    },
    {
        column:"column2",
       
        rows:{
            row1: [
                {
                    name: "Init",
                   label:"Init.BranchDetails",
                    component: "backlink",
                    action: "openPackageModal",
                    sx:{
                        mt:4
                    }
                   
                }
            ],
            row2:[
                {
                    name: "State",
                    label: "State/Province",
                    component: "text-field",   
                   

                },
            ],
            row3:[
                {
                    name: "telephone",
                    label: "Telephone",
                    component: "text-field",   
                   

                },

            ],
            row4:[
                {
                    name: "fax",
                    label: "Fax",
                    component: "text-field",   
                   

                },

            ],
            row5:[
                {
                    name:"email",
                    label:"Email",
                    component:"text-field"

                }
            ],
        }
    }
]
}